module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/icon-quality-apparel-064dc5483999d33bbfc82fffa182baf8.svg";